import * as React from "react";

import {
    Show,
    SimpleShowLayout,
    ShowProps,
    FunctionField,
    DateField,
    TopToolbar
} from "react-admin";
import { convertBasketItemsToString } from '../order/OrderUtil'
import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import { apolloClient as client } from "../data-provider/graphqlDataProvider";

let token: any = localStorage.getItem('credentials')
// const client = new ApolloClient({
//     uri: `${process.env.REACT_APP_DATAPROVIDER}`,
//     headers: { authorization: token },
//     cache: new InMemoryCache(),
// });

const ListActions = (props: any) => {
    return (
        <TopToolbar>
            {/* <EditButton record={props.data} label="ویرایش" /> */}
            {/* Add your custom actions */}
        </TopToolbar>
    )
};

// var allAuthUsers: Array<any> = [];
// async function getAllAuthUsers() {
//     const GET_AuthUsers = gql`
//   query GetAuthUserss($where: AuthUserWhere){
//     authUsers(where: $where){
//       id      
//       firstName
//       lastName        
//     }
//   }
//   `;
//     allAuthUsers = await client.query({
//         query: GET_AuthUsers,
//         variables: {
//             where: { authMethods: { some: { service: { equals: process.env.REACT_APP_AUTH_SERVICE } } } }
//         }
//     }).then((res) => {
//         return res.data.authUsers;
//     })
// }

const getCustomer = (customer: any) => {
    //   let authUser = allAuthUsers.find(au => au.id === customer)
    //   return (authUser?.firstName && authUser?.lastName) ? `${authUser?.firstName} ${authUser?.lastName}` : '-'

}

const usedDiscountStatus: any = {
    Used: 'استفاده شده',
    Reserved: 'رزرو شده',
    Expired: 'منقضی شده',
    Canceled: 'لغو شده'
}

const getCodeDiscounts = (discounts: any) => {
    let discountHtml = discounts.map((obj: any) => {
        return (
            `${obj.discount.code} | ${usedDiscountStatus[obj.status]}`
        )
    })
    return discountHtml;
}

export const OrderShow = (props: ShowProps): React.ReactElement => {
    const [status, setStatus] = React.useState("");
    const [statusDate, setStatusDate] = React.useState("");
    // const [basketItemsTitle, setBasketItemsTitle] = React.useState("")
    const [invoice, setInvoice] = React.useState<any>();

    async function getOrderStatus(orderId: any) {
        const GET_OrderStatuses = gql`
        query OrderStatuses($where: OrderStatusWhereInput, $orderBy: [OrderStatusOrderByInput!]) {
            orderStatuses(where: $where, orderBy: $orderBy) {
              id
              status
              createdAt
            }
          }
      `;
        let result: Array<any> = await client.query({
            query: GET_OrderStatuses,
            variables: {
                where: {
                    order: { id: orderId }
                },
                orderBy: { createdAt : "Desc"}
            }

        }).then((res) => {
            return res.data.orderStatuses;
        })
        let sortedReuslt = [...result]
    
        var statusTitle = ""
        switch (sortedReuslt[0].status) {
            case "Created": {
                statusTitle = "ارسال پیامک";
                break;
            }
            case "PaymentSuccess": {
                statusTitle = "پرداخت موفق";
                break;
            }
            case "PaymentFailure": {
                statusTitle = "پرداخت ناموفق";
                break;
            }
            default: {
                statusTitle = "تست";
                break;
            }
        }
        setStatus(statusTitle);
        const date = new Date(sortedReuslt[0].createdAt);
        let toShamsi = date.toLocaleDateString('fa-IR') + ' - ' + date.toLocaleTimeString('fa-IR');
        setStatusDate(toShamsi)
    }

    async function getInvoice(orderId: any) {
        await axiosWithAuthInterceptor.get(`${process.env.REACT_APP_LEMONADE_SERVER}/api/orders/${orderId}/invoice`,)
        .then((res: any) => {
            if (!res.data.err)
                setInvoice(res.data)
        })
    }


    React.useEffect(() => {     
        getOrderStatus(props.id).then(res => {
            getInvoice(props.id)
        });
        // getBasketItemsTitle(props.id)
        //getAllAuthUsers()


    }, [])

    return (
        <Show actions={<ListActions />} {...props}>
            <SimpleShowLayout>
                <div style={{width: '100%', display: 'flex', alignItems: 'center', gap: '1rem', fontFamily: 'IranSans-Bold', fontSize: '14px'}}>
                    <p>کد تخفیف‌ها | وضعیت کد تخفیف:</p>
                    <FunctionField
                        id="discount-test"                  
                        render={(record: any) => record.usedDiscounts.length > 0 ? getCodeDiscounts(record.usedDiscounts) : '-'}
                    >
                    </FunctionField>
                </div>

                <div style={{width: '100%', display: 'flex', alignItems: 'center', gap: '1rem', fontFamily: 'IranSans-Bold', fontSize: '14px'}}>
                    <p>کمپین:</p>
                    <FunctionField                        
                        render={(record: any) => record.meta?.utmCampaign ? record.meta.utmCampaign : '-'}
                    >
                    </FunctionField>
                </div>

                <div style={{width: '100%', display: 'flex', alignItems: 'center', gap: '1rem', fontFamily: 'IranSans-Bold', fontSize: '14px'}}>
                    <p>قیمت اصلی:</p>
                    <FunctionField
                        style={{ direction: 'rtl' }}                        
                        render={(record: any) => invoice ? `${invoice?.totalOriginalPrice.toLocaleString()} تومان` : '-'}
                    />
                </div>

                <div style={{width: '100%', display: 'flex', alignItems: 'center', gap: '1rem', fontFamily: 'IranSans-Bold', fontSize: '14px'}}>
                    <p>قیمت نهایی:</p>
                    <FunctionField
                        style={{ direction: 'rtl' }}                        
                        render={(record: any) => invoice ? `${invoice?.totalPrice.toLocaleString()} تومان` : '-'}
                    />
                </div>

                <div style={{width: '100%', display: 'flex', alignItems: 'center', gap: '1rem', fontFamily: 'IranSans-Bold', fontSize: '14px'}}>
                    <p>وضعیت سفارش:</p>
                    <FunctionField                        
                        render={() => status}
                    />
                </div>
                
                <div style={{width: '100%', display: 'flex', alignItems: 'center', gap: '1rem', fontFamily: 'IranSans-Bold', fontSize: '14px'}}>
                    <p>تاریخ ثبت وضعیت:</p>
                    <FunctionField
                        label="تاریخ ثبت وضعیت"
                        render={() => statusDate}
                    />
                </div>
                

                {/* <FunctionField
                    label="خریدار"
                    render={(record: any) => getCustomer(record.customer)}
                /> */}
                {/* {
                    status !== "" ?
                        (
                            <FunctionField
                                label="وضعیت سفارش"
                                render={() => status}
                            />
                        ) : 'Loading'
                } */}
                {/* {
                    statusDate !== "" ?
                        (
                            <FunctionField
                                label="تاریخ ثبت وضعیت"
                                render={() => statusDate}
                            />
                        ) : 'Loading'
                } */}


                <div style={{width: '100%', display: 'flex', alignItems: 'center', gap: '1rem', fontFamily: 'IranSans-Bold', fontSize: '14px'}}>
                    <p>محصولات:</p>
                    <FunctionField                        
                        render={(record: any) => convertBasketItemsToString(record.basketItems)}
                    />
                </div>

                <div style={{width: '100%', display: 'flex', alignItems: 'center', gap: '1rem', fontFamily: 'IranSans-Bold', fontSize: '14px'}}>
                    <p>شناسه پرداخت:</p>
                    <FunctionField                        
                        render={(record: any) => record.paymentId ? record.paymentId : "-"}
                    />
                </div>

                <div style={{width: '100%', display: 'flex', alignItems: 'center', gap: '1rem', fontFamily: 'IranSans-Bold', fontSize: '14px'}}>
                    <p>تاریخ ایجاد:</p>
                    <DateField source="createdAt" showTime={true} locales="fa-IR" />
                </div>

                

            </SimpleShowLayout>
        </Show >
    );
};
